// extracted by mini-css-extract-plugin
export var circle = "_ew-1";
export var exitConfirmationModal = "_ew-5";
export var iframe = "_ew-0";
export var offline = "_ew-3";
export var online = "_ew-2";
export var workstationSelectError = "_ew-4";